import { useRef, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { slug } from "@/lib/geo";

const plain = (t) => t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

export const CountryPicker = ({ names, exclude, onPick, label, testId, className }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const listRef = useRef(null);
  const options = names.filter((n) => !exclude.includes(n));
  const pick = (n) => { onPick(n); setOpen(false); setQ(""); };
  // Return confirms the highlighted country; done by hand because iPhone keyboards often send it mid-word, which the list ignores
  const onKeyDown = (e) => {
    if (e.key !== "Enter" && e.keyCode !== 13) return;
    e.preventDefault();
    e.stopPropagation();
    const hit = listRef.current?.querySelector('[cmdk-item][data-selected="true"]')?.getAttribute("data-value");
    const t = plain(e.currentTarget.value || q);
    const match = options.find((n) => n === hit) || options.find((n) => plain(n) === t) || options.find((n) => plain(n).startsWith(t)) || options.find((n) => plain(n).includes(t));
    if (t && match) pick(match);
  };
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }}>
      <PopoverTrigger asChild>
        <Button size="sm" data-testid={testId} className={className}><Plus size={14} /> {label}</Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-72" align="end">
        <Command>
          <CommandInput placeholder="Search country…" value={q} onValueChange={setQ} onKeyDown={onKeyDown}
            enterKeyHint="done" autoCorrect="off" autoCapitalize="words" spellCheck={false} data-testid={`${testId}-search`} />
          <CommandList ref={listRef}>
            <CommandEmpty>No country found.</CommandEmpty>
            <CommandGroup>
              {options.map((n) => (
                <CommandItem key={n} value={n} onSelect={() => pick(n)} data-testid={`${testId}-option-${slug(n)}`}>
                  {n}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
